module.exports = __webpack_public_path__ + "static/media/018.7fd7f425.png";